export type ModuleId =
  | 'maintenance'
  | 'bank_reconciliation'
  | 'amenities'
  | 'voting'
  | 'vehicles'
  | 'documents'
  | 'vendors'
  | 'tenancy_lease'
  | 'reports';

export interface ModuleDefinition {
  id: ModuleId;
  name: string;
  description: string;
}

export const MODULE_REGISTRY: Record<ModuleId, ModuleDefinition> = {
  maintenance: {
    id: 'maintenance',
    name: 'Maintenance & Work Orders',
    description: 'Work order tickets, contractor dispatching, cost attribution, and photo attachments.',
  },
  bank_reconciliation: {
    id: 'bank_reconciliation',
    name: 'Bank Statement Import',
    description: 'CSV/OFX bank statement parsing and cryptographic deduplication for manual review.',
  },
  amenities: {
    id: 'amenities',
    name: 'Amenity Reservations',
    description: 'Shared common area reservation calendar (rooftop terrace, BBQ, meeting rooms).',
  },
  voting: {
    id: 'voting',
    name: 'Digital HOA Voting & Polls',
    description: 'Digital resolutions, contractor quote polling, and weighted voting quorums.',
  },
  vehicles: {
    id: 'vehicles',
    name: 'Vehicles & Parking',
    description: 'License plate registry, parking bay allocations, and resident vehicle management.',
  },
  documents: {
    id: 'documents',
    name: 'Document Storage & Sharing',
    description: 'Organized repository for bylaws, meeting minutes, contracts, and insurance certificates.',
  },
  vendors: {
    id: 'vendors',
    name: 'Vendors & Contractors',
    description: 'Directory of registered vendors, contractors, and emergency hotlines for the property.',
  },
  tenancy_lease: {
    id: 'tenancy_lease',
    name: 'Tenancy',
    description:
      'Lease terms, renter invitations, tenancy lifecycle, and owner-controlled manager access.',
  },
  reports: {
    id: 'reports',
    name: 'Financial Reports',
    description:
      'Reserve fund flows, operating margins, expense breakdowns, and collection trajectories.',
  },
};

export interface PropertyModuleGrant {
  module_id: string;
  roles: string[] | null;
}

export function normalizeModules(grants: PropertyModuleGrant[] | undefined | null): string[] {
  if (!grants) return [];
  return grants.map((g) => g.module_id);
}

export function moduleAllowsRole(grant: PropertyModuleGrant | undefined | null, role: string): boolean {
  if (!grant) return false;
  if (!grant.roles || grant.roles.length === 0) return true;
  return grant.roles.includes(role);
}
